import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="3k06x1v86utys">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.14em] sm:text-sm ${dark ? "text-rose-soft" : "text-rose"}`} data-id="element-68" data-mp="3k29j646802y8">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 text-balance font-serif text-[30px] font-bold leading-[1.15] sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-69" data-mp="gieyfxzjrbrm">
        {title}
      </h2>
      {intro && <p className={`mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed ${dark ? "text-white/80" : "text-muted"}`} data-id="element-70" data-mp="6sc49ugovrrp">
          {intro}
        </p>}
    </div>;
}